class ProductMediaSlider {
  constructor(element) {
    this.element = element;
    this.container = element.querySelector('.product-media-slider__container');
    this.content = element.querySelector('.product-media-slider__content');
    this.items = Array.from(element.querySelectorAll('.product-media-slider__item'));
    this.thumbnails = Array.from(element.querySelectorAll('.product-media-slider__thumbnail'));
    this.prevButton = element.querySelector('.product-media-slider__button--prev');
    this.nextButton = element.querySelector('.product-media-slider__button--next');
    this.skeleton = element.querySelector('.product-media-slider__skeleton');
    
    this.currentIndex = 0;
    this.isAnimating = false;
    
    this.init();
  }
  
  init() {
    // Set initial active state
    this.updateActiveState();
    
    // Add event listeners
    this.prevButton.addEventListener('click', () => this.prev());
    this.nextButton.addEventListener('click', () => this.next());
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => this.goTo(index));
    });
    
    // Preload images
    this.preloadImages();
  }
  
  preloadImages() {
    const images = this.items.map(item => {
      const img = item.querySelector('img');
      return img ? img.src : null;
    }).filter(Boolean);
    
    let loadedCount = 0;
    
    images.forEach(src => {
      const img = new Image();
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          this.skeleton.setAttribute('data-loaded', 'true');
        }
      };
      img.src = src;
    });
  }
  
  updateActiveState() {
    this.items.forEach((item, index) => {
      item.setAttribute('data-active', index === this.currentIndex);
    });
    
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.setAttribute('data-active', index === this.currentIndex);
    });
  }
  
  prev() {
    if (this.isAnimating) return;
    this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    this.updateActiveState();
  }
  
  next() {
    if (this.isAnimating) return;
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    this.updateActiveState();
  }
  
  goTo(index) {
    if (this.isAnimating || index === this.currentIndex) return;
    this.currentIndex = index;
    this.updateActiveState();
  }
}

// Initialize all sliders on the page
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.product-media-slider');
  sliders.forEach(slider => new ProductMediaSlider(slider));
}); 